import * as React from "react";

import type { DesignaliProps } from "../../types";

export const Typescript = React.forwardRef<SVGSVGElement, DesignaliProps>(
  ({ ...props }, forwardedRef) => {
    return (
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="24"
        height="24"
        viewBox="0 0 24 24"
        {...props}
        ref={forwardedRef}
      >
        <path
          strokeWidth={0}
          fill="#3178c5"
          d="M2,20.21V3.78c.02-.07.02-.13.02-.2.03-.38.22-.69.46-.96.21-.24.47-.41.76-.53.15-.06.31-.06.47-.07.03,0,.06,0,.08,0h16.43c.09.02.17.01.26.02.31.03.57.18.81.37.29.22.49.51.62.85.08.19.07.39.08.59v16.33c.06.89-.68,1.61-1.36,1.79-.15.04-.3.04-.46.05H3.85s-.04,0-.05,0c-.03,0-.06-.01-.1,0-.38,0-.7-.16-.99-.4-.28-.22-.48-.51-.61-.84-.06-.16-.06-.33-.08-.5,0-.01,0-.03,0-.04Z"
        />
        <path
          strokeWidth={0}
          fill="#fff"
          d="M19.98,13.43s-.06-.02-.08-.03c-.43-.27-.91-.43-1.41-.51-.27-.04-.54-.06-.82-.04-.25.02-.49.07-.72.17-.12.06-.23.13-.33.23-.23.24-.26.59-.08.86.08.12.19.23.3.31.19.14.4.26.61.36.28.13.57.25.85.37.34.15.68.33.99.54.33.23.61.51.8.87.15.27.22.56.25.86.03.34.02.68-.07,1.02-.14.57-.47,1-.95,1.32-.36.23-.75.37-1.16.45-.68.13-1.36.15-2.04.08-.45-.04-.89-.12-1.32-.27-.12-.04-.24-.09-.35-.15-.04-.02-.06-.04-.06-.09,0-.61,0-1.23,0-1.84,0,0,0-.02,0-.03.03,0,.05.03.07.04.49.39,1.04.64,1.66.76.45.08.89.1,1.34,0,.19-.04.36-.12.52-.23.36-.27.36-.73.16-1.02-.11-.16-.26-.29-.42-.39-.26-.17-.54-.3-.82-.43-.33-.15-.67-.27-.99-.44-.34-.18-.65-.39-.92-.66-.41-.42-.62-.92-.65-1.5-.02-.36.01-.72.14-1.07.19-.5.54-.88,1-1.16.38-.23.79-.36,1.22-.44.58-.11,1.16-.11,1.74-.07.48.03.94.11,1.39.27.15.05.12.02.12.17,0,.52,0,1.05,0,1.57v.11Z"
        />
        <path
          strokeWidth={0}
          fill="#fff"
          d="M11.1,16.67c0,1.14,0,2.28,0,3.42,0,.03,0,.05,0,.08,0,.07,0,.07-.08.07-.61,0-1.22,0-1.82,0-.08,0-.08,0-.08-.08,0-.03,0-.06,0-.09,0-2.28,0-4.55,0-6.83,0-.16.01-.14-.14-.14-.74,0-1.48,0-2.22,0-.03,0-.05,0-.08,0-.04,0-.05-.01-.05-.05,0-.02,0-.03,0-.05,0-.47,0-.93,0-1.4,0-.01,0-.03,0-.04,0-.05.01-.08.06-.07.02,0,.03,0,.05,0,2.25,0,4.51,0,6.76,0,0,0,.02,0,.03,0,.08,0,.08,0,.08.08,0,.12,0,.23,0,.35,0,.35,0,.7,0,1.04,0,.02,0,.04,0,.06,0,.07,0,.07-.07.07-.03,0-.05,0-.08,0-.74,0-1.48,0-2.22,0-.02,0-.05,0-.07,0-.07,0-.07,0-.07.08,0,.23,0,.46,0,.69,0,.93,0,1.87,0,2.8Z"
        />
      </svg>
    );
  },
);

export default Typescript;
